/**--external-- */
import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

/**--internal-- */
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import {
  DeleteOutlined,
  DownArrowOutlined,
  UpArrowOutlined,
} from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";

/**--relative-- */
import classes from "./ElementContextMenu.scss";
import { LABELLING_CATEGORY } from "../Labelling/LabellingConstant";

// * Menu separator
const Separator = () => <div className={classes.contextMenuButtonSeparator} />;

/**
 *
 * @param { node, onClick  }
 * @returns Button to remove element from canvas
 */
const RemoveItemButton = ({ node, onClick = () => {} }) => {
  const handleRemoveItem = () => {
    const id = node.id();
    onClick(id);
  };

  return (
    <IconButton
      dsVersion="2.0"
      type="plain"
      variant="neutral"
      _legacy_variant="plain"
      onClick={handleRemoveItem}
      icon={<DeleteOutlined size="xx-small" variant="critical" />}
      testId="worksheet-labelling-elementContextMenu-removeItem"
    />
  );
};

/**
 *
 * @param { node, onClick  }
 * @returns Button to order elements on canvas category wise
 */
const OrderItemButtons = ({ t, node, onOrderElement = () => {} }) => {
  const handleOrderElement = type => {
    const id = node.id();
    onOrderElement(id, type);
  };

  return (
    <>
      <Tooltip tooltip={t("workbook:bring_to_front")}>
        <IconButton
          dsVersion="2.0"
          type="plain"
          variant="neutral"
          _legacy_variant="plain"
          onClick={() => handleOrderElement("UP")}
          icon={<UpArrowOutlined size="xx-small" variant="subtle" />}
          testId="worksheet-labelling-elementContextMenu-orderElementUp"
        />
      </Tooltip>
      <Tooltip tooltip={t("workbook:send_to_back")}>
        <IconButton
          dsVersion="2.0"
          type="plain"
          variant="neutral"
          _legacy_variant="plain"
          onClick={() => handleOrderElement("DOWN")}
          icon={<DownArrowOutlined size="xx-small" variant="subtle" />}
          testId="worksheet-labelling-elementContextMenu-orderElementDown"
        />
      </Tooltip>
    </>
  );
};

/**
 *
 *
 *
 *
 * @param {*} props
 * @returns ElementContextMenu
 */
const ElementContextMenu = (props = {}) => {
  const { t } = useI18n();

  const { node, onRemove = () => {}, onOrderElement = () => {} } = props;
  if (!node) return null;

  const name = node.name();
  const isLabelNode = _.first(_.split(name, "#")) === LABELLING_CATEGORY.LABEL;
  const isArrowNode = _.includes(name, "ARROW");

  return (
    <>
      {!isLabelNode && !isArrowNode && (
        <>
          <OrderItemButtons t={t} node={node} onOrderElement={onOrderElement} />
          <Separator />
        </>
      )}
      <RemoveItemButton node={node} onClick={onRemove} />
    </>
  );
};

export default ElementContextMenu;

ElementContextMenu.defaultProps = {
  node: {},
  onRemove: () => {},
  onChange: () => {},
  onOrderElement: () => {},
};

ElementContextMenu.propTypes = {
  node: PropTypes.any,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  onOrderElement: PropTypes.func,
};
